import { Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[set-focus]'
})
export class SetFocusDirective {

  constructor(element: ElementRef) {
    this.element = element;

  }

  ngOnInit() {

  }

  ngAfterViewInit() {
    this.element.nativeElement.focus();
  }

}
